var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.8,
    height: 13.8,
    viewBox: "0 0 21.8 13.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".menu-a{fill:none;stroke:#8a8fb5;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3599.1 -113.1)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "menu-a",
    x2: 20,
    transform: "translate(3600 114)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "menu-a",
    x2: 20,
    transform: "translate(3600 120)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "menu-a",
    x2: 20,
    transform: "translate(3600 126)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.3a9c6994310e9a4410d0001a8d1da612.svg";
export { ForwardRef as ReactComponent };